import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Search from "@/pages/customer/Search";
import LaundryDetail from "@/pages/customer/LaundryDetail";
import Orders from "@/pages/customer/Orders";
import PaymentStatus from "@/pages/customer/PaymentStatus";
import ManagerDashboard from "@/pages/manager/ManagerDashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import DriverDashboard from "@/pages/driver/DriverDashboard";
import SetPassword from "@/pages/SetPassword";
import Terms from "@/pages/Terms";
import RatePage from "@/pages/RatePage";
import DriversPage from "@/pages/DriversPage";
import PartnersPage from "@/pages/PartnersPage";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/set-password" element={<SetPassword />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/rate/:token" element={<RatePage />} />
              <Route path="/drivers" element={<DriversPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/search" element={<Search />} />
              <Route path="/laundry/:id" element={<LaundryDetail />} />
              <Route path="/payment-status" element={<PaymentStatus />} />
              <Route path="/orders" element={<ProtectedRoute roles={["customer"]}><Orders /></ProtectedRoute>} />
              <Route path="/manager" element={<ProtectedRoute roles={["laundry_manager"]}><ManagerDashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute roles={["admin", "staff"]}><AdminDashboard /></ProtectedRoute>} />
              <Route path="/driver" element={<ProtectedRoute roles={["driver"]}><DriverDashboard /></ProtectedRoute>} />
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
